import React from 'react';
import ScrollToTop from "react-scroll-to-top";
import '../styles/footer.css';
function Footer() {
  return (
    <div className="footer">
      <ScrollToTop style={{background:"rgb(27,66,122)"}} smooth="true" color="white" />
    <p>© Designed and Created by Rishabh Kumar 2023</p>
  </div>
  );
}

export default Footer;
